// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"keywords_suggest-module__wrapper--2Byoc","title":"keywords_suggest-module__title--1qgH5"};